import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Card, CardContent, Box } from '@mui/material';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  dataDeleteRequestList,
  CompanyGdprSettingsDTO,
  CandidateDataDeleteRequestDTO,
  getCompanyGDPRSettingsByLoggedineRecruiter,
} from 'wisestep-api';
import { WsButton, WsDatePicker, WsListingLoader } from 'wisestep-base';
import { string, object } from 'yup';

import NoDataFoundCard from '../../../components/noDataFoundCard';
import ErrorLogger from '../../../providers/ErrorLogger';
import DeleteRequestsLayout from '../components/DeleteRequestsLayout';

import DeleteReqCandidateCard from './DeleteReqCandidateCard';

const DeleteRequestsPage = () => {
  const [settings, setSettings] = useState<CompanyGdprSettingsDTO>();
  const [dataDeleteRequest, setDataDeleteRequest] = useState<CandidateDataDeleteRequestDTO[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const today = new Date();

  const validationSchema = object().shape({
    fromDate: string().required('Please enter From Date'),
  });

  const defaultValues = {
    fromDate: today,
  };
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  };
  const methods = useForm(formOptions);
  const { handleSubmit } = methods;

  const getDeleteData = useCallback(
    async (fromDate: string) => {
      const list = await dataDeleteRequestList(settings?.id as string, fromDate);

      if (list.data) {
        setDataDeleteRequest(list.data);
      }
    },
    [settings?.id]
  );

  useEffect(() => {
    const today = new Date(new Date().toUTCString());
    const loadData = async () => {
      let settingsResponse;
      try {
        settingsResponse = await getCompanyGDPRSettingsByLoggedineRecruiter();
        setSettings(settingsResponse.data);
      } catch (e) {
        console.log('Error in loading data');
      }
      await getDeleteData(dayjs(today).format('YYYY-MM-DD'));
    };
    loadData();
    setLoader(true);
  }, [getDeleteData]);

  const onFormSubmit = async (data: FieldValues) => {
    try {
      await getDeleteData(data.fromDate);
      setLoader(true);
    } catch (e) {
      console.log('Error in delete request page');
    }
  };

  return (
    <>
      <DeleteRequestsLayout title="Delete Requests" indexLabel="Delete Request">
        <Card sx={{ minHeight: '3vw', width: '100%' }}>
          <CardContent>
            <Grid container spacing={4}>
              <Grid item xs={10}>
                <FormProvider {...methods}>
                  <form>
                    <WsDatePicker label="Select date" name="fromDate" disableFuture={true} />
                  </form>
                </FormProvider>
              </Grid>
              <Grid item xs={2} mt={1}>
                <WsButton
                  variant="contained"
                  size="large"
                  type="submit"
                  onClick={handleSubmit(onFormSubmit)}
                >
                  Search
                </WsButton>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
          <Box mr={2}>
            {loader ? (
              !isEmpty(dataDeleteRequest) ? (
                <Box pl={2}>
                  {dataDeleteRequest.map((candidate, index) => (
                    <Box my={2} key={index}>
                      <DeleteReqCandidateCard
                        candidateIndex={index}
                        candidateDeleteDTO={candidate ?? ''}
                        candidateList={dataDeleteRequest}
                      />
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box px={2} pt={4}>
                  <NoDataFoundCard text="No Candidates Found" />
                </Box>
              )
            ) : (
              <WsListingLoader />
            )}
          </Box>
        </ErrorBoundary>
      </DeleteRequestsLayout>
    </>
  );
};
export default DeleteRequestsPage;
